import { useState } from "react";

interface Props {
  shareCode: string;
}

export function ShareLink({ shareCode }: Props) {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}/play/${shareCode}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input
        type="text"
        readOnly
        value={url}
        className="w-64 px-3 py-1.5 text-sm border rounded bg-gray-50"
      />
      <button
        onClick={handleCopy}
        className="px-4 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
      >
        {copied ? "Copied!" : "Copy Link"}
      </button>
    </div>
  );
}
